import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Encumbrance } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import EncumbrancesTableRow from './EncumbrancesTableRow';
import { useEncumbrancesTable } from '../context/EncumbrancesTableContext';

const EncumbrancesTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useEncumbrancesTable();

  const hasData = data.encumbrances?.length > 0;

  const rows = data.encumbrances!.map(
    (encumbrance: Encumbrance, index: number) => (
      <EncumbrancesTableRow
        // eslint-disable-next-line react/no-array-index-key
        key={`encumbrance-row-${index}`}
        index={index}
        encumbrance={encumbrance}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoEncumbrancesMessage')}
    />
  );
};

export default EncumbrancesTableBody;
